import type { Analytics } from "@models/analytics.model";

interface TeamMember {
    employee_id: number;
    first_name?: string;
    last_name?: string;
    role: string;
}

const ROLE_LABEL: Record<string, string> = {
    ENGAGEMENT_MANAGER: "Ops Lead",
    CONTENT_LEAD: "Content Lead",
    CLIENT_SUCCESS_MANAGER: "Client Success Manager",
    SALES_LEAD: "Sales Lead",
    DATA_MANAGER: "Data Manager",
};

function initials(first?: string, last?: string): string {
    return `${(first?.[0] ?? "").toUpperCase()}${(last?.[0] ?? "").toUpperCase()}`;
}

export default function DedicatedEngagementTeam({ analytics }: { analytics: Analytics }) {
    const team: TeamMember[] = analytics.charts?.["team-list"] ?? [];

    return (
        <div className="dash-card">
            <div className="dash-card__head">
                <span className="dash-card__title">Dedicated Engagement Team</span>
            </div>
            <div className="dash-card__body">
                {team.length === 0 ? (
                    <div className="dash-empty">No team members assigned.</div>
                ) : (
                    team.map((m) => (
                        <div key={m.employee_id} className="team-row">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span className="team-row__avatar">{initials(m.first_name, m.last_name)}</span>
                                <div>
                                    <div style={{ fontWeight: 600, fontSize: 14 }}>
                                        {m.first_name} {m.last_name}
                                    </div>
                                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                                        {ROLE_LABEL[m.role] ?? m.role}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
